@if (hasContent()) {
<div class="flex flex-column gap-4">

  @if (isSubscription()) {
    <!-- Sits with the two cost blocks it explains, rather than at the top of the dialog where it
         described something the reader could not yet see. -->
    <div class="flex align-items-start gap-3">
      <i class="pi pi-info-circle text-xl"></i>
      <span>{{ 'CREATE_ORDER.SUBSCRIPTION.TWO_ORDERS_INFO' | translate }}</span>
    </div>

    @if (subscriptionSummary(); as sub) {
    <div class="summary-section flex flex-column gap-2">
      <span class="font-semibold">{{ 'CREATE_ORDER.SUBSCRIPTION.ORDER_TO_FINANCING' | translate }}</span>
      <div class="flex justify-content-between gap-3">
        <span>{{ 'CREATE_ORDER.SUBSCRIPTION.FINANCING_COMPANY' | translate }}</span>
        <span>{{ sub.financingCompany }}</span>
      </div>
      <div class="flex justify-content-between gap-3">
        <span>{{ 'CREATE_ORDER.SUBSCRIPTION.MONTHLY_PRICE' | translate }}</span>
        <span>{{ sub.monthlyPrice | coreCurrency }}</span>
      </div>
      <div class="flex justify-content-between gap-3 font-semibold">
        <span>{{ 'CREATE_ORDER.SUBSCRIPTION.ORDER_VALUE' | translate }}</span>
        <span>{{ sub.objectValue | coreCurrency }}</span>
      </div>
    </div>

    <div class="summary-section flex flex-column gap-2">
      <span class="font-semibold">{{ 'CREATE_ORDER.SUBSCRIPTION.ORDER_TO_CUSTOMER' | translate }}</span>
      <div class="flex justify-content-between gap-3 font-semibold">
        <span>{{ 'CREATE_ORDER.SUBSCRIPTION.ORDER_VALUE' | translate }}</span>
        <span>{{ sub.customerOneTimeTotal | coreCurrency }}</span>
      </div>
    </div>
    }
  } @else {
    @if (orderSummary(); as order) {
    <div class="summary-section flex flex-column gap-2">
      <span class="font-semibold">{{ 'CREATE_ORDER.SUBSCRIPTION.ORDER_TO_CUSTOMER' | translate }}</span>
      @if (order.customer) {
      <div class="flex justify-content-between gap-3">
        <span>{{ 'CREATE_ORDER.VALIDATION.CUSTOMER.NAME' | translate }}</span>
        <span>{{ order.customer }}</span>
      </div>
      }
      <div class="flex justify-content-between gap-3">
        <span>{{ 'CREATE_ORDER.SUMMARY.ORDER_VALUE_EX_VAT' | translate }}</span>
        <span>{{ order.orderValueExVat | coreCurrency }}</span>
      </div>
      <div class="flex justify-content-between gap-3 font-semibold">
        <span>{{ 'CREATE_ORDER.SUMMARY.TOTAL_INC_VAT' | translate }}</span>
        <span>{{ order.totalIncVat | coreCurrency }}</span>
      </div>
    </div>
    }
  }

  <!-- The split is frozen by this action: once the order exists the quote is locked and the
       shares can no longer be edited. Worth seeing before, not after. -->
  @if (salesTeamSummary(); as team) {
  <div class="summary-section flex flex-column gap-2">
    <div class="flex justify-content-between align-items-baseline gap-3">
      <span class="font-semibold">{{ 'QUOTE.DETAIL.OVERVIEW.SALES_TEAM' | translate }}</span>
      @if (team.pot) {
      <span class="text-sm text-secondary">
        {{ 'QUOTE.DETAIL.OVERVIEW.SALES_CREDIT.POT_LABEL' | translate }}
        {{ team.pot | coreCurrency }}
      </span>
      }
    </div>

    @if (team.responsible) {
    <div class="flex justify-content-between gap-3">
      <span>{{ 'QUOTE.DETAIL.OVERVIEW.SALES_PERSON' | translate }}</span>
      <span>{{ team.responsible }}</span>
    </div>
    }

    @for (row of team.rows; track row.salesPersonId) {
    <div class="flex justify-content-between align-items-baseline gap-3">
      <span class="flex flex-column">
        <span>{{ row.name }}</span>
        @if (row.roles || row.company) {
        <span class="text-sm text-secondary">
          {{ row.roles }}@if (row.roles && row.company) {<span> · </span>}{{ row.company }}
        </span>
        }
      </span>
      <span class="white-space-nowrap">
        {{ row.share }} %
        @if (row.amount !== null) {
        <span class="text-sm text-secondary ml-2">{{ row.amount | coreCurrency }}</span>
        }
      </span>
    </div>
    }
  </div>
  }
</div>
}
